import { Avatar, Tooltip } from "antd"
import ExpenseTagColumn from "Components/expenseTagColumn"
import React from "react"
import { useTranslation } from "react-i18next"
import { usePurchaseOrdersEmployees } from "../hooks/usePurchaseOrderEmployees.hook"
import { IsServiceIcon } from "../icons/IsServiceIcon"
import { ShoppingBagIcon } from "../icons/ShoppingBagIcon"
import { PurchaseOrder } from "../types/PurchaseOrder.interfaces"

export const TodoTableNameField = ({ record }: { record: PurchaseOrder }) => {
    const { t } = useTranslation()
    const { getApproverName } = usePurchaseOrdersEmployees()

    const approver = getApproverName(record)
    return (
        <div className="flex image-loader gap-10 flex-no-wrap items-center">
            <Avatar
                src={"#"}
                icon={record.isService ? <IsServiceIcon /> : <ShoppingBagIcon />}
                size={38}
                style={{
                    background: "rgba(111, 186, 255, 0.10)",
                }}
                className="flex-shrink-0 bg-[rgba(111,186,255,0.10)] flex rounded-full border-none justify-center items-center"
            />
            <div className="flex-1 overflow-hidden">
                <div className="font-bold text-15 text-[#181c32] truncate">
                    {approver.firstName} {approver.lastName} ({t("label:approver")})
                </div>

                <div className="flex">
                    <Tooltip title={record.purchaseOrderNumber}>
                        <div className="text-[#6B7280] text-sm leading-tight truncate font-normal w-full"># {record.purchaseOrderNumber}</div>
                    </Tooltip>

                    {record.tags ? (
                        <div className="mb-10 h-14">
                            <ExpenseTagColumn expenseTagIds={record.tags} />
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    )
}
